<template>
    <div>
        <b-row align-v="center" align-h="between" v-if="!['GameEnd', 'Ranking'].includes(dayStage)">
            <b-col md="5">
                <h1>Day {{dayNum}}</h1>
            </b-col>
            <b-col>
                <h2 v-if="dayStage==='Supplier'">
                    Purchasing phase&nbsp;<span class="nowrap">
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#F7941D" d="M13.3 7.7L0 0v15.3z"/></svg>
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                    </span>
                </h2>
                <h2 v-if="dayStage==='Customer'">Sales phase&nbsp;<span class="nowrap">
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#d6edfc" d="M13.3 7.7L0 0v15.3z"/></svg>
                    <svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.3 15.3"><path fill="#5185B4" d="M13.3 7.7L0 0v15.3z"/></svg>
                    </span>
                </h2>
            </b-col>
        </b-row>
        <b-row v-if="!['GameEnd', 'Ranking'].includes(dayStage)">
            <b-col align-v="end" class="text-center">
                <h2 class="price" key="2"  v-if="dayStage==='Supplier' && $root.store.currentDay < $root.store.nboDays">A. Supplier Price: $<div class="random-monospace random-frame-1">
                        <transition name="random" appear>
                            <div class="random" v-html="supplierPrice+randomGen"></div>
                        </transition>
                    </div>
                </h2>
                <h2 class="price" key="1" v-if="dayStage==='Customer'">A. Customer Price: <span class="random-monospace">$</span><div class="random-monospace random-frame-2">
                        <transition name="random" appear>
                            <div class="random" v-html="customerPrice+randomGen">
                            </div>
                        </transition>
                    </div>
                </h2>
            </b-col>
        </b-row>
        <b-row class="mt-4 gameend" v-if="['GameEnd', 'Ranking'].includes(dayStage)">
            <b-col>
                <img src="@/assets/end.svg">
                <h2>End of the game!</h2>
            </b-col>
        </b-row>
    </div>

</template>

<script>
    export default {
        name: "CurrentPhase",
        props: {
            dayNum: Number,
            dayStage: String
        },
        computed: {
            debug() {
                return 'debug' in this.$route.query;
            },
            days() {
                return this.$root.$data.store.days;
            },
            randomGen()
            {
                return '0453386475668369126874203127722456847118518118905049373063640445614984272665739406245400974402082908';
            },
            customerPrice() {
                return this.days.length ? this.days[this.dayNum-1].customerPrice : '--';
            },
            supplierPrice() {
                return this.days.length ? this.days[this.dayNum-1].supplierPrice : '--';
            },
        }
    }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap');

.gameend  {
    text-align: center;
}

.gameend img {
    width: 80%;
    max-width: 300px;
}

.nowrap {
    white-space: nowrap;
}
.chevron {
    padding: 0 2px;
    height: 40px;
}

.random-monospace {
    font-family: 'Roboto Mono', monospace;
}
.random-enter-active {
    animation: randomGen .7s steps(50) 1;
}

div.random-frame-1 /* .random-leave-active below version 2.1.8 */ {
    display:inline-block;
    vertical-align:top;
    width: 1ch;
    overflow: hidden;
}

div.random-frame-2  /* .random-leave-active below version 2.1.8 */ {
    display:inline-block;
    vertical-align:top;
    width: 2ch;
    overflow: hidden;
}

@keyframes randomGen {
    100% { transform: translateX(-5000%); }
}


#pause:checked ~ div div {
  animation-play-state: paused;
}


</style>

